(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-button-group"] = factory();
	else
		root["vue-button-group"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 34:
/***/ (function(module) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 502:
/***/ ((module, __nested_webpack_exports__, __nested_webpack_require_533__) => {

"use strict";
__nested_webpack_require_533__.r(__nested_webpack_exports__);
/* harmony export */ __nested_webpack_require_533__.d(__nested_webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_533__(467);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_533__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_533__(715);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__nested_webpack_require_533__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_533__(329);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__nested_webpack_require_533__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2__);
// Imports



var ___CSS_LOADER_URL_IMPORT_0___ = new URL(/* asset import */ __nested_webpack_require_533__(332), __nested_webpack_require_533__.b);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL(/* asset import */ __nested_webpack_require_533__(619), __nested_webpack_require_533__.b);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL(/* asset import */ __nested_webpack_require_533__(430), __nested_webpack_require_533__.b);
var ___CSS_LOADER_EXPORT___ = _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
var ___CSS_LOADER_URL_REPLACEMENT_0___ = _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_getUrl_js__WEBPACK_IMPORTED_MODULE_2___default()(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sf-btn{align-items:center;background-color:#52ae30;border-radius:24px;border:0;color:#fff;cursor:pointer;display:inline-flex;font:700 16px/1.5 Source Sans Pro,Arial,sans-serif;justify-content:center;padding:12px 32px;transition:.2s}.sf-btn:focus{outline:2px solid #6fb4d8;outline-offset:5px;-moz-outline-radius:24px}.sf-btn::-moz-focus-inner{border:0}.sf-btn:active,.sf-btn:focus,.sf-btn:hover{background-color:#74bf1e;color:#fff;text-decoration:none}.sf-btn:active:focus{outline:none}@media screen and (-ms-high-contrast:active){.sf-btn{box-shadow:inset 0 0 0 2px}}.sf-btn[disabled=disabled]{background-color:#ababab;pointer-events:none}.sf-btn svg:first-child{margin-right:4px}.sf-btn svg:last-child{margin-left:4px}.sf-btn--highlighted{background-color:#f60;border-radius:32px;color:#fff;line-height:24px;padding:16px 40px}@media screen and (-ms-high-contrast:active){.sf-btn--highlighted{box-shadow:inset 0 0 0 4px}}.sf-btn--highlighted:active,.sf-btn--highlighted:focus,.sf-btn--highlighted:hover{background-color:#ff802b}.sf-btn--error{background-color:#ff435a}.sf-btn--error:active,.sf-btn--error:focus,.sf-btn--error:hover{background-color:#ff5c6f}.sf-btn.sf-btn--small{padding:4px 32px}.sf-btn.sf-btn--small:focus{background-color:#428b26}.sf-btn.sf-btn--small[disabled=disabled]{background-color:#f7f7f7;color:#ababab;pointer-events:none}.sf-btn.sf-btn--small-secondary{background-color:#fff;border:1px solid #52ae30;color:#52ae30;padding:4px 32px}.sf-btn.sf-btn--small-secondary:active,.sf-btn.sf-btn--small-secondary:hover{background-color:#fff;border:2px solid #74bf1e;color:#74bf1e;padding:3px 31px}.sf-btn.sf-btn--small-secondary:focus{background-color:#fff;border:2px solid #428b26;color:#428b26;padding:3px 31px}.sf-btn.sf-btn--small-secondary[disabled=disabled]{background-color:#fff;border:1px solid #ababab;color:#ababab;pointer-events:none}.sf-btn--link,.sf-btn--link-error{background-color:transparent!important;font-weight:600;padding:0}@media screen and (-ms-high-contrast:active){.sf-btn--link,.sf-btn--link-error{box-shadow:none}}.sf-btn--link-error:active,.sf-btn--link-error:focus,.sf-btn--link-error:hover,.sf-btn--link:active,.sf-btn--link:focus,.sf-btn--link:hover{text-decoration:underline}.sf-btn--link-error[disabled=disabled],.sf-btn--link[disabled=disabled]{color:#d0d8e8}.sf-btn--link,.sf-btn--link:active,.sf-btn--link:focus,.sf-btn--link:hover{color:#52ae30}.sf-btn--link-error,.sf-btn--link-error:active,.sf-btn--link-error:focus,.sf-btn--link-error:hover{color:#ff435a}.sf-btn--link-dropdown{background-color:transparent!important;color:#52ae30;font-weight:600;padding:0;position:relative;text-align:left}@media screen and (-ms-high-contrast:active){.sf-btn--link-dropdown{box-shadow:none}}.sf-btn--link-dropdown:active,.sf-btn--link-dropdown:focus,.sf-btn--link-dropdown:hover{color:#74bf1e}.sf-btn--link-dropdown[disabled=disabled]{color:#d0d8e8}.sf-btn--link-dropdown:after{border-bottom:1px solid currentColor;border-right:1px solid currentColor;content:"";display:inline-block;height:7px;margin-left:8px;right:0;top:calc(50% - 1px);transform:translateY(-50%) rotate(45deg);transform-origin:center 5px;transition:.2s;width:7px}.sf-btn--link-dropdown.sf-btn--link-dropdown-open:after{transform:translateX(10%) translateY(-10%) rotate(225deg)}.sf-btn--full-width{display:block;width:100%}[class*=sf-btn--chevron]{border-radius:24px;height:48px;padding:0;width:48px;overflow:hidden;position:relative;text-indent:-9999px}[class*=sf-btn--chevron]:after{background:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50%;content:"";display:block;height:48px;top:0;left:0;width:48px;position:absolute}[class*=sf-btn--chevron][disabled]{background-color:#f1f1f1;pointer-events:none;cursor:not-allowed}[class*=sf-btn--chevron][disabled]:after{background:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 50%}.sf-btn--chevron-right:after{transform:rotate(180deg)}[class*=sf-btn--exchange]{border-radius:24px;height:48px;padding:0;width:48px;overflow:hidden;position:relative;text-indent:-9999px}[class*=sf-btn--exchange]:before{top:24px}[class*=sf-btn--exchange]:after,[class*=sf-btn--exchange]:before{background:url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 50%;position:absolute;content:"";height:10px;left:0;width:48px}[class*=sf-btn--exchange]:after{top:14px;transform:rotate(180deg)}[class*=sf-btn--group-item]{background-color:#fff;border:1px solid #fff;border-radius:24px;box-shadow:0 4px 8px rgba(73,92,136,.15);color:#1b1f27;cursor:pointer;display:block;font-family:Source Sans Pro,sans-serif;font-size:18px;font-weight:700;line-height:24px;margin:0;padding:31px 0;text-align:center;transition:all .3s;width:100%}[class*=sf-btn--group-item]:focus,[class*=sf-btn--group-item]:hover{background-color:#fff;border:1px solid rgba(82,174,48,.5);color:#1b1f27}@media(min-width:768px){[class*=sf-btn--group-item]{border-radius:32px}}.sf-btn--exchange-vertical{transform:rotate(90deg)}.sf-btn--left{display:block;margin-right:auto}.sf-btn--center{display:block;margin:0 auto}.sf-btn--right{display:block;margin-left:auto}.sf-button-container{display:flex}`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 715:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 329:
/***/ ((module) => {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    options = {};
  }
  if (!url) {
    return url;
  }
  url = String(url.__esModule ? url.default : url);

  // If url is already wrapped in quotes, remove them
  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  }
  if (options.hash) {
    url += options.hash;
  }

  // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls
  if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), "\"");
  }
  return url;
};

/***/ }),

/***/ 467:
/***/ ((module) => {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 663:
/***/ ((module, __unused_webpack_exports, __nested_webpack_require_11855__) => {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_11855__(502);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__nested_webpack_require_11855__(514)/* ["default"] */ .Z)
var update = add("14fcf9b2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 514:
/***/ ((__unused_webpack_module, __nested_webpack_exports__, __nested_webpack_require_12428__) => {

"use strict";

// EXPORTS
__nested_webpack_require_12428__.d(__nested_webpack_exports__, {
  Z: () => (/* binding */ addStylesClient)
});

;// CONCATENATED MODULE: ../../node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ../../node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 430:
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDIwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cgk8cGF0aCBkPSJNMTkgMUgxTDYgNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";

/***/ }),

/***/ 619:
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDggMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDFMMC45OTk5OTggN0w3IDEzIiBzdHJva2U9IiNBQkFCQUIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";

/***/ }),

/***/ 332:
/***/ ((module) => {

"use strict";
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDggMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDFMMC45OTk5OTggN0w3IDEzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __nested_webpack_require_20935__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __nested_webpack_require_20935__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_20935__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__nested_webpack_require_20935__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__nested_webpack_require_20935__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__nested_webpack_require_20935__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__nested_webpack_require_20935__.o(definition, key) && !__nested_webpack_require_20935__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__nested_webpack_require_20935__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__nested_webpack_require_20935__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__nested_webpack_require_20935__.p = "";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		__nested_webpack_require_20935__.b = document.baseURI || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			566: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// no jsonp function
/******/ 	})();
/******/ 	
/************************************************************************/
var __nested_webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXPORTS
__nested_webpack_require_20935__.d(__nested_webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_20935__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueButton.vue?vue&type=template&id=cadcb79c&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({ref:"button",staticClass:"sf-btn",class:[_vm.buttonType && _vm.buttonType != 'primary' ? `sf-btn--${_vm.buttonType}` : '', _vm.fullWidth ? `sf-btn--full-width` : '', _vm.align ? `sf-btn--${_vm.align}` : ''],style:(_vm.maxWidthStyling)},'button',_vm.$attrs,false),this.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueButton.vue?vue&type=script&lang=js&


const TYPES = [
	'primary',
	'highlighted',
	'error',
	'small',
	'small-secondary',
	'link',
	'link-error',
	'link-dropdown',
	'chevron-left',
	'chevron-right',
	'exchange-horizontal',
	'exchange-vertical',
	'group-item'
];
const ALIGNS = ['left', 'center', 'right'];
/* harmony default export */ const VueButtonvue_type_script_lang_js_ = ({
	inheritAttrs: false,
	name: 'VueButton',
	mixins: [a],
	props: {
		/**
		Visual theme of the button
		 */
		buttonType: {
			type: String,
			default: TYPES[0],
			validator(val) {
				return TYPES.includes(val);
			}
		},
		/**
		Makes the button width 100%. Ignores maxWidth
		 */
		fullWidth: {
			required: false,
			type: Boolean,
			default: false
		},
		/**
		The maximum width of the button (over the predefined mobile viewport size)
		 */
		maxWidth: {
			required: false,
			type: Number
		},
		/**
		Horizontal align value of the button
		 */
		align: {
			type: String,
			validator(val) {
				return ALIGNS.includes(val);
			}
		}
	},
	computed: {
		maxWidthStyling() {
			return !this.fullWidth && this.maxWidth && !this.isMobile ? `max-width: ${this.maxWidth}px; width: 100%` : null;
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueButton.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueButtonvue_type_script_lang_js_ = (VueButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../../node_modules/vue-style-loader/index.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[4]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueButton.vue?vue&type=style&index=0&id=cadcb79c&prod&lang=scss&
var VueButtonvue_type_style_index_0_id_cadcb79c_prod_lang_scss_ = __nested_webpack_require_20935__(663);
;// CONCATENATED MODULE: ./src/components/VueButton.vue?vue&type=style&index=0&id=cadcb79c&prod&lang=scss&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueButton.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueButtonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ const VueButton = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueButton);


})();

__nested_webpack_exports__ = __nested_webpack_exports__["default"];
/******/ 	return __nested_webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-button.umd.js.map

/***/ }),

/***/ 687:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(467);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(715);
/* harmony import */ var _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_vue_cli_service_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sr-only[data-v-3cbee8f4]{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sf-button-group[data-v-3cbee8f4],.sf-button-group--in-modal[data-v-3cbee8f4]{border:0 none;max-width:544px;padding:0}.sf-button-group__container[data-v-3cbee8f4]{display:flex;flex-flow:wrap;justify-content:space-between;align-content:space-between}.sf-button-group__item[data-v-3cbee8f4]{width:100%}@media(min-width:768px){.sf-button-group .sf-button-group__container[data-v-3cbee8f4]{margin:-16px}}@media(max-width:767px){.sf-button-group .sf-button-group__container .sf-button-group__item[data-v-3cbee8f4]{margin-bottom:24px}.sf-button-group .sf-button-group__container .sf-button-group__item[data-v-3cbee8f4]:last-child{margin-bottom:0}}@media(min-width:768px){.sf-button-group .sf-button-group__container .sf-button-group__item[data-v-3cbee8f4]{height:128px;margin:16px;width:calc(50% - 32px)}}@media(min-width:996px){.sf-button-group--in-modal .sf-button-group__container[data-v-3cbee8f4]{margin:-16px}}@media(max-width:995px){.sf-button-group--in-modal .sf-button-group__container .sf-button-group__item[data-v-3cbee8f4]{margin-bottom:24px}.sf-button-group--in-modal .sf-button-group__container .sf-button-group__item[data-v-3cbee8f4]:last-child{margin-bottom:0}}@media(min-width:996px){.sf-button-group--in-modal .sf-button-group__container .sf-button-group__item[data-v-3cbee8f4]{height:128px;margin:16px;width:calc(50% - 32px)}}`, ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 715:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 467:
/***/ ((module) => {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 792:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(514)/* ["default"] */ .Z)
var update = add("6670e37f", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 514:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ addStylesClient)
});

;// CONCATENATED MODULE: ../../node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

;// CONCATENATED MODULE: ../../node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueButtonGroup.vue?vue&type=template&id=3cbee8f4&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isInModal ? 'sf-button-group--in-modal' : 'sf-button-group',attrs:{"role":"group"}},[_c('div',{staticClass:"sf-button-group__container"},_vm._l((_vm.options),function(option,index){return _c('div',{staticClass:"sf-button-group__item"},[_c('VueButton',{attrs:{"id":_vm.uuid + index,"aria-describedby":option.ariaDescribedBy,"button-type":"group-item"},on:{"click":function($event){return _vm.$emit('change', option.key)}}},[_vm._v(_vm._s(option.value))])],1)}),0)])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

// EXTERNAL MODULE: ../../node_modules/@ui-common/vue-button/dist/vue-button.umd.js
var vue_button_umd = __webpack_require__(34);
var vue_button_umd_default = /*#__PURE__*/__webpack_require__.n(vue_button_umd);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueButtonGroup.vue?vue&type=script&lang=js&



/* harmony default export */ const VueButtonGroupvue_type_script_lang_js_ = ({
	mixins: [l],
	name: 'VueButtonGroup',
	data: () => ({
		model: null
	}),
	props: {
		/**
		 * Object which containes the rendered radio group items (input, label)
		 */
		options: {
			type: Array,
			required: true
		},
		/**
		 * Decides whether the component has only desktop breakpoint (display in modal) or normal (tablet and desktop) breakpoints
		 */
		isInModal: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	components: {
		VueButton: (vue_button_umd_default())
	}
});

;// CONCATENATED MODULE: ./src/components/VueButtonGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueButtonGroupvue_type_script_lang_js_ = (VueButtonGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../../node_modules/vue-style-loader/index.js??clonedRuleSet-62.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-62.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-62.use[2]!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-62.use[3]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-62.use[4]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueButtonGroup.vue?vue&type=style&index=0&id=3cbee8f4&prod&lang=scss&scoped=true&
var VueButtonGroupvue_type_style_index_0_id_3cbee8f4_prod_lang_scss_scoped_true_ = __webpack_require__(792);
;// CONCATENATED MODULE: ./src/components/VueButtonGroup.vue?vue&type=style&index=0&id=3cbee8f4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueButtonGroup.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueButtonGroupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "3cbee8f4",
  null
  
)

/* harmony default export */ const VueButtonGroup = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueButtonGroup);


})();

__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-button-group.umd.js.map